import { useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'

// Libs
import { fetchThemeProductList } from '@/api/fetchThemeProductList'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { MALL_DEFAULT_PAGE_SIZE } from '@/constants/mall'

// Types

export type LiveListType = {
  kolName: string
  title: string
  coverPhotoUrl: string
  startTime: string
  endTime: string
  liveType: number
  dummyViews: number
  roomId: string
  kolHeadshotUrl: string
}

export type LiveListData = {
  roomList: LiveListType[]
  totalPage: {
    totalCount: number
    totalPage: number
  }
}

interface IParams {
  pageSize: number
}

const defaultLiveListParams: IParams = { pageSize: MALL_DEFAULT_PAGE_SIZE }

export const useThemeProductList = (themeId: string, { params = defaultLiveListParams }: any) => {
  const { pageSize } = params
  const router = useRouter()
  const defaultPageNo = 1

  const themeProductListData = useInfiniteQuery(
    [QUERY_KEY.FETCH_THEME_PRODUCT_LIST, { themeId }],
    ({ pageParam = defaultPageNo }) =>
      fetchThemeProductList(themeId, {
        pageSize,
        pageNo: pageParam,
      }),
    {
      getNextPageParam: (lastPage, pages) => {
        if (!router.isReady) return undefined

        const currentPage = pages.length
        const totalPage = lastPage?.totalPage.totalPages
        let result: number | undefined = 0
        const allPageData = JSON.stringify({ data: pages })
        const emptyPageDataIdentifier = '"productsInfo":null'

        if (allPageData.includes(emptyPageDataIdentifier)) {
          result = undefined
          return
        }

        if (lastPage?.totalPage.totalPages === 0) {
          result = undefined
        } else {
          result = currentPage === totalPage ? undefined : currentPage + 1
        }

        return result
      },
    },
  )

  return themeProductListData
}
